import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { DayAttendanceComponent } from './views/attendance/day-attendance/day-attendance.component';
import { UserMonthlyAttendanceComponent } from './views/attendance/user-monthly-attendance/user-monthly-attendance.component';
import { MonthlyAttendanceComponent } from './views/attendance/monthly-attendance/monthly-attendance.component';
import { ProfileComponent } from './views/settings/profile/profile.component';
import { WorkingDaysComponent } from './views/settings/working-days/working-days.component';
import { ProjectsComponent } from './views/settings/projects/projects.component';
import { EmployeeComponent } from './views/settings/employee/employee.component';
import { LogoutComponent } from './views/logout/logout.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ExpensesComponent } from './views/expenses/expenses.component';
import { PersonalProfileComponent } from './views/staff/employee/employee.component';
import { PersonalDashboardComponent } from './views/staff/dashboard/dashboard.component';
import { MyExpensesComponent } from './views/staff/expenses/expenses.component';
import { SalaryUploadComponent } from './views/settings/salary-upload/salary-upload.component';
import { SalaryComponent } from './views/salary/salary.component';
import { MySalaryComponent } from './views/staff/salary/salary.component';
import { VisitReportComponent } from './views/visit-report/visit-report.component';
import { LeaveRequestComponent } from './views/leave-request/leave-request.component';
import { OrganizationComponent } from './views/settings/organization/organization.component';
import { ExperienceLetterUploadUploadComponent } from './views/settings/experience-letter-upload/experience-letter-upload.component';
import { ExperienceLetterComponent } from './views/experience-letter/experience-letter.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'login/:redirected',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'logout',
    component: LogoutComponent,
    data: {
      title: 'Logout'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
        data: {
          title: 'Dashboard'
        }
      },
      {
        path: 'myDashboard',
        component: PersonalDashboardComponent,
        data: {
          title: 'Dashboard'
        }
      },
      {
        path: 'expenses',
        component: ExpensesComponent,
        data: {
          title: 'Expenses'
        }
      },
      {
        path: 'visit_report',
        component: VisitReportComponent,
        data: {
          title: 'Visit Report'
        }
      },
      {
        path: 'leave_request',
        component: LeaveRequestComponent,
        data: {
          title: 'Leave Request'
        }
      },
      {
        path: 'myExpenses',
        component: MyExpensesComponent,
        data: {
          title: 'Expenses'
        }
      },
      {
        path: 'salary',
        component: SalaryComponent,
        data: {
          title: 'Salary'
        }
      },
      {
        path: 'experience_letter',
        component: ExperienceLetterComponent,
        data: {
          title: 'Expereience Letter'
        }
      },
      {
        path: 'mySalary',
        component: MySalaryComponent,
        data: {
          title: 'Salary'
        }
      },

      {
        path: 'profile',
        component: PersonalProfileComponent,
        data: {
          title: 'Profile'
        }
      },
      {
        path: 'attendance',
        children: [
          {
            path: 'dayAttendance',
            component: DayAttendanceComponent,
            data: {
              title: 'Daily Attendance Report'
            }
          },
          {
            path: 'userMonthlyAttendance',
            component: UserMonthlyAttendanceComponent,
            data: {
              title: 'Monthly Attendance'
            }
          },
          {
            path: 'monthlyAttendance',
            component: MonthlyAttendanceComponent,
            data: {
              title: 'Monthly Attendance'
            }
          }
        ]
      },
      {
        path: 'setting',
        data: {
          title: 'Settings'
        },
        children: [
          {
            path: 'user',
            component: ProfileComponent,
            data: {
              title: 'User'
            }
          },
          {
            path: 'working_days',
            component: WorkingDaysComponent,
            data: {
              title: 'Working Days'
            }
          },
          {
            path: 'organization',
            component: OrganizationComponent,
            data: {
              title: 'Organization'
            }
          },
          {
            path: 'projects',
            component: ProjectsComponent,
            data: {
              title: 'Projects'
            }
          },
          {
            path: 'employee',
            component: EmployeeComponent,
            data: {
              title: 'Employee'
            }
          },
          {
            path: 'uploadSalary',
            component: SalaryUploadComponent,
            data: {
              title: 'Salary Upload'
            }
          },
          {
            path: 'uploadExpereienceLetter',
            component: ExperienceLetterUploadUploadComponent,
            data: {
              title: 'Expereience Upload'
            }
          },
        ]
      }

    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
